var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Welcome',{attrs:{"msg":"Welcome to Flavors Stock App"}}),_c('router-link',{attrs:{"to":"/logout"}},[_vm._v(" Logout ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }